<template>
<div class="d-flex h-100 w-100"  v-if="hasRole(roles.RW_REAL_ESTA_CRED)">
  <div class="col-md-3">
  <SearchSalesReportBroker v-on:search="search" v-on:setSearch="setSearch" v-on:setCustomDate="setCustomDate"></SearchSalesReportBroker>
  </div>
  <div class="col-md-9">
    <div id="card-sales">
      <div v-show="!haveData"  id="img-card-sales">
          <img id="img-card"  src="https://static.zopone.com.br/img/realestate/ReportNotFound.png">
      </div>
      <div v-if="hasData">
        <div v-if="onlyTable" >
          <tablesalereportmonth
            v-for="(report, i) in reportEnterprise"
            :key="i"
            :dataSales="report"
            :columns="columns"
          ></tablesalereportmonth>
        </div>
        <div v-else :key="containerBoards" class="container-boards">
          <div id="board-auto" v-for="(mes, i) in meses" v-bind:key="mes">
            <BoardSaledReportsBroker
                ref="BoardSale"
                v-if="i <= currentyMonth || customDate"
                :mes="mes"
                :posicaoMes="i"
                :dataSalesProp="filterByMonth(i)"
                v-on:getDataSales="getDataSales"
            ></BoardSaledReportsBroker>
          </div>
        </div>
      </div>

      <div v-else>
        <div :class="containerImgReportClass">
          <img class="img" src="https://static.zopone.com.br/img/realestate/ReportNotFound.png" />
        </div>
      </div>

  </div>
</div>
</div>
</template>

<script>
import SalesReportsBroker from './salesreportsbroker'
export default SalesReportsBroker

</script>

<style scoped>
.img {
  width: 60%;
  height: fit-content;
}
#form-seacch{
  display: flex;
  flex-direction: column;
  align-content: center;
}

.periodos{
 display: flex;
 flex-wrap: wrap;
 justify-content: space-around;
}

.arrow-angel{
  padding-top: 10px;
  font-size: 30px;
  color: black;
  padding-right: 24px;
}

.acording{
  display: flex;
  justify-content: space-between;
  padding-left: 20px;
  background-color: #ECEFF1;
  border-radius: 0px;
  height: 50px;
  width: 100%;
}
.mes{
  font-size: 22px;
  color: black;
  padding-top: 16px;
  font-weight: bold;
}

.footer{
  margin-bottom: 10%;
}

.btn-periodos{
  background-color: #EBEBEB;
  height: 30px;
  margin-top: 5px;
  margin-bottom: 5px;
  width: 130px;
  font-weight: bold;
  color: grey;
  border-radius: 25px;
  padding: 5px;
  border: 1px solid rgb(77, 77, 77);
}

.btn-periodos-active{
   background-color: #008148;
  height: 30px;
  margin-top: 5px;
  margin-bottom: 5px;
  width: 130px;
  font-weight: bold;
  color: white;
  border-radius: 25px;
  padding: 5px;
  border: 1px solid rgb(77, 77, 77);
}

.labelseach{
  margin-bottom: 3px;
  font-size: 14px;
  font-weight: bold;
}

#card-sales{
  height: 75vh;
  overflow: auto;
  width: 100%;
  padding: 15px;
  border: 1px solid rgb(180, 180, 180);
  background-color: white;
}
#img-card-sales{
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

#img-card{
  height: 490px;
  width: 490px;
  object-fit: contain;
}

#board-auto{
  overflow: auto;
}

.container-img-reports{
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.invisible{
  display: none;
}

</style>



// WEBPACK FOOTER //
// src/views/private/realestate/salesreportsbroker/salesreportsbroker.vue